import { lumi } from "@/lib/lumi"
import { assets } from "@/lib/assets"
import { useState, type FormEvent } from "react"
import { Link } from "react-router-dom"
import toast from "react-hot-toast"

function AdminLogin() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (submitting) return
    setSubmitting(true)
    try {
      await lumi.auth.signInWithPassword({
        email: email.trim(),
        password,
      })
      window.location.href = "/admin"
    } catch (error: unknown) {
      const err = error as { message?: string }
      toast.error(err?.message || "登入失敗，請確認帳號密碼")
      setSubmitting(false)
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#eef3f6] px-6 py-16">
      <div className="w-full max-w-md border border-[#d5dde3] bg-[#f7f3ec] px-8 py-10 shadow-[0_24px_60px_rgba(43,68,86,0.12)]">
        <img src={assets.logo} alt="江美琪限定香氛" className="h-10 w-auto" />
        <p className="mt-8 font-display text-xs tracking-[0.36em] text-slate-400">STUDIO LEDGER</p>
        <h1 className="mt-3 font-serif-tc text-3xl tracking-[0.18em] text-slate-800">訂單後台</h1>
        <p className="mt-3 text-[13px] leading-7 text-slate-500">
          請以管理員帳號登入，查看並管理江美琪限定香氛訂單。
        </p>
        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
          <label className="block">
            <span className="mb-2 block text-[12px] tracking-[0.12em] text-slate-400">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="h-11 w-full border border-slate-300 bg-white/80 px-3 text-[13px] text-slate-700 outline-none focus:border-slate-500"
            />
          </label>
          <label className="block">
            <span className="mb-2 block text-[12px] tracking-[0.12em] text-slate-400">密碼</span>
            <input
              type="password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="h-11 w-full border border-slate-300 bg-white/80 px-3 text-[13px] text-slate-700 outline-none focus:border-slate-500"
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            className="h-12 w-full bg-[#2b4456] text-[12px] tracking-[0.32em] text-white transition hover:bg-[#1d3342] disabled:opacity-60"
          >
            {submitting ? "登入中…" : "進入後台"}
          </button>
        </form>
        <Link to="/" className="mt-6 block text-center text-[11px] tracking-[0.16em] text-slate-400">
          返回官網
        </Link>
      </div>
    </main>
  )
}

export default AdminLogin
